import React, { useEffect, useState } from 'react'
import { assetsListModel } from '../assetsListModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from "@/views/base/organization/orgModel";
import { assetsMoveService } from '../../assetsMove/assetsMoveService'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = assetsListModel()
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const [departmentOutList, setDepartmentOutList] = useState<any>([]);   //用于搜索展示的数据

    useEffect(() => {
        assetsMoveService.getDepartmentOutList({}).then(({ retData }) => {
            if (retData.length > 0) {
                setDepartmentOutList(retData.filter((list) => list).map((item) => {
                    return {
                        label: item.departmentName,
                        value: item.department
                    }
                }))
            } else {
                setDepartmentOutList([])
            }
        })
    }, [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资编码',
            fieldName: 'materialCode',
            span: 5
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资名称',
            fieldName: 'materialName',
            span: 5
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '是否占用',
        //     fieldName: 'occupy',
        //     options: [{label:'是',value:1},{label:'否',value:0}],
        //     span:6
        // },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "所属部门",
            fieldName: "department",
            span: 5,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '所属部门(选)',
        //     fieldName: 'department',
        //     options: departmentOutList,
        //     // span:3,
        // },
        {
            type: SearchTypeEnum.Input,
            placeholder: '所属部门(输)',
            fieldName: 'departmentName',
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '使用人',
            fieldName: 'user',
            span: 5,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '资产状态',
            fieldName: 'status',
            options: getSelectedDictOne(DictCodeEnmu.ASSETS_STATUS),
            mode: "multiple",
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '仓库',
            fieldName: 'warehouseName',
            span: 5,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '货位',
            fieldName: 'shelfCode',
            span: 5,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '是否部门在用',
            fieldName: 'departmentStatus',
            options: [{ label: '在用', value: 'assets-status.isUse' }, { label: '闲置', value: 'assets-status.leaveUnused' }],
            span: 4
        },
    ]


    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
